import { createReducer } from 'redux-starter-kit';
import { SET_DRAGGED_ITEM } from './actions';

const INITIAL_STATE = {
  draggedItem: {}
};

export default createReducer(INITIAL_STATE, {
  [SET_DRAGGED_ITEM]: (state, action) => {
    state.draggedItem = action.payload;
  }
});
